import { render, staticRenderFns } from "./ShopLayout.vue?vue&type=template&id=4ac469df&"
import script from "./ShopLayout.vue?vue&type=script&lang=js&"
export * from "./ShopLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports